export const PALLETS = {
  NAVY: "#1a114a",
  PURPLE: "#0b1bb0",
  LIGHTPURPLE: "#aaa5f2",
  RED: "#db3107",
  DARKGRAY: "#999999",
  GRAY: "#B7B9C1",
  LIGHTGRAY: "#e8e8e8",
  BEIGE: "#f7f7f7",
  BLACK: "#000000",
  WHITE: "#ffffff",
};
